import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { Row } from 'react-bootstrap'
import { AltaContext } from './AltaContext'

function Steps() {
  const { paso } = useContext(AltaContext)
  return Number(paso) !== 5 ? (
    <div className="container py-3 mb-3">
      <Row>
        <div className="col-lg-12 order-md-2">
          <div className="steps flex-sm-nowrap">
            <Link to="#" className={`step ${paso === 1 && 'active'}`}>
              {paso > 1 && <i className="material-icons check_circle" />}
              <h4 className="step-title">1. Términos y Condiciones</h4>
            </Link>
            <Link to="#" className={`step ${paso === 2 && 'active'}`}>
              {paso > 2 && <i className="material-icons check_circle" />}
              <h4 className="step-title">2. Datos del Contribuyente</h4>
            </Link>
            <Link to="#" className={`step ${paso === 3 && 'active'}`}>
              {paso > 3 && <i className="material-icons check_circle" />}
              <h4 className="step-title">3. Datos de la Actividad Comercial</h4>
            </Link>
            <Link to="#" className={`step ${paso === 4 && 'active'}`}>
              {paso > 4 && <i className="material-icons check_circle" />}
              <h4 className="step-title">4. Comprobante</h4>
            </Link>
          </div>
        </div>
      </Row>
    </div>
  ) : (
    <></>
  )
}

export default Steps
